window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};

window['CP_IT_Sitewide_03_shopify'] = function () {
  if (document.querySelector('.mobile-menu-drawer-open #menu-drawer') && !document.querySelector('.CP_IT_Sitewide_03_shopify') && window.innerWidth < 768) {
    document.body.classList.add('CP_IT_Sitewide_03_shopify');

    const style = document.createElement("style");
    style.textContent = `
    .menu-drawer {
      width: 85% !important;
    }
    .menu-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
      padding: 10px 20px;
    }
    .menu-img-tile {
      position: relative;
      border-radius: 10px;
      overflow: hidden;
      text-decoration: none;
      width: 100%;
      aspect-ratio: 1/1;
      display: block;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      align-items: flex-end !important;
      display: flex !important;
      justify-content: center !important;
    }
    .menu-tile img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      background: #fff;
    }
    .menu-img-tile.full {
      grid-column: span 2;
      aspect-ratio: 2/1;
    }
    .menu-img-tile.tile-no-overlay .tile-overlay {
      display: none;
    }
    .tile-overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0.5) 50%, transparent 100%);
      padding: 8px 0;
    }
    .tile-label {
      width: 100%;
      padding: 4px 4px;
      font-size: 13px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      display: block;
    }
    .tile-subtitle {
      display: block;
      font-size: 10px;
      font-weight: 400;
      margin-top: 3px;
      opacity: 0.9;
      line-height: 1.2;
      text-transform: capitalize;
    }
    .tws-l1-panel .small-menu {
      display: block !important;
    }
    .tws-l1-panel .small-menu a.tws-l1.solo {
      display: flex !important;
      align-items: center;
      padding: 12px 10px;
      gap: 10px;
      font-size: 14px;
      font-weight: 500;
      text-decoration: none;
      color: #000;
    }
    .menu-img-tile.full.tile-no-overlay {
      background-size: contain;
      height: auto;
      aspect-ratio: 1 / 0.28;
      padding: 0px;
      margin: 0px;
    }
    .menu-img-tile.full  {
      grid-column: span 2;
      aspect-ratio: 2 / 0.6;
    }
    .tws-l1-panel .small-menu a.tws-l1.solo img {
      width: 25px;
      height: 25px;
      object-fit: contain;
    }
  
    /* review css  */
    .reviews-section {
      padding: 0 15px;
      font-family: Arial, sans-serif;
      position: relative;
      max-width: 420px;
      margin: 0 auto;
    }
    .reviews-wrapper {
      overflow: hidden;
    }
    .reviews-container {
      display: flex;
      transition: transform 0.5s ease-in-out;
    }
    .reviews-card {
      flex: 0 0 100%;
      min-width: 100%;
      box-sizing: border-box;
      border: 1px solid #F3C96B;
      border-radius: 8px;
      padding: 16px;
      background: #fff;
    }
    .reviews-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 10px;
    }
    .reviews-left {
      display: flex;
      align-items: center;
    }
    .reviews-initials {
      background: #2E5A3A;
      color: #fff;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      font-weight: bold;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      flex-shrink: 0;
    }
    .reviews-meta {
      display: flex;
      flex-direction: column;
      gap: 0;
    }
    .reviews-name {
      line-height: 1.2;
      color: #363636;
      font-family: Montserrat;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
    }
    .reviews-date {
      font-size: 12px;
      color: #555;
    }
    .reviews-stars {
      color: #00B67A;
      font-size: 16px;
      white-space: nowrap;
      transform: translateY(-5px);
    }
    .reviews-stars-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end; 
    }
    .reviews-text {
      color: #363636;
      line-height: 1.5;
      font-family: Montserrat;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      align-items: center;
    }
    .pagination-dots {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 24px;
    }
    
      .reviews-dot {
      width: 30px !important;
      height: 5px !important;
      background-color: #C5C4C2 !important;
      border-radius: 6px !important;
      margin: 0 4px !important;
      display: inline-block !important;
      opacity: 1 !important;
      visibility: visible !important;
      font-size: 0 !important;
      line-height: 0 !important;
      overflow: hidden !important;
    }
      .reviews-dot.active {
      background-color: #ff0000 !important;
      width: 30px !important;
      border-radius: 6px !important;
    }
    
    
  /* Header css */
  
    #Details-menu-drawer-container[open] ~ .header {
      display: none !important;
    }
    
      #menu-drawer {
      position: fixed !important;
      top: 0;
      left: 0;
      height: 100vh;
      width: 100vw;
      max-width: 100%;
      background: white;
      z-index: 9999 !important;
      /*overflow-y: auto;*/
      overflow: hidden;
    }
  
      .drawer-header-wrapper {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 12px 16px;
      border-bottom: 1px solid #ddd;
      background: #fff;
    }
    
      .logonew {
      width: 72px !important;
      height: 37.8px !important;
    }
    
      .drawer-close-btn {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
    
      .drawer-close-btn svg {
      width: 24px;
      height: 24px;
      color: #000;
    }
      .tws-l1-panel .small-menu a.tws-l1.solo[href*="occasions-festivals"]:after {
    content: "NEW";
    font-size: 70%;
    background: #223C52;
    color: #fff;
    font-weight: 500;
    font-family: 'Montserrat', sans-serif;
    display: flex;
    padding: 2px 5px;
    border-radius: 2px;
    line-height: normal;
    align-items: center;
    justify-content: center;
}

.menu-grid > a[href*="ekdum-fresh"],
.tws-l1-panel .small-menu a.tws-l1.solo[href*="wholesale"],
.tws-l1-panel .small-menu a.tws-l1.solo[href*="fabric-care-compendium"] {
    position: relative;
}

.menu-grid > a[href*="ekdum-fresh"]::after,
.tws-l1-panel .small-menu a.tws-l1.solo[href*="wholesale"]:after,
.tws-l1-panel .small-menu a.tws-l1.solo[href*="fabric-care-compendium"]:after {
    content: "";
    position: absolute;
    top: 8px;
    right: 8px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #ff0000;
    box-shadow: 0 0 4px 2px rgba(255, 0, 0, 0.6);
    animation: lighting-blip 1.2s infinite ease-in-out;
}

@keyframes lighting-blip {
    0%, 100% {
        opacity: 0.3;
        background: #ff0000;
        box-shadow: 0 0 5px 2px rgba(255, 0, 0, 0.3);
    }
    50% {
        opacity: 1;
        background: #ff0000;
        box-shadow: 0 0 7px 3px rgba(255, 0, 0, 0.9);
    }
}



.tws-l1-panel .small-menu a.tws-l1.solo[href*="wholesale"]:after,
.tws-l1-panel .small-menu a.tws-l1.solo[href*="fabric-care-compendium"]:after {
    position: relative;
    width: 6px;
    height: 6px;
    margin-left: 5px;
    top: -1px;
    right: 0;
}
    body:has(.menu-drawer-container[open]) slideshow-component.slider-mobile-gutter .slider-counter {
    display: none;
}
    `;
    document.head.appendChild(style);


    (() => {

      const imgSrc = {
        'NEW!': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/untitled_design_00852406-c920-42d6-bd31-9ea3f2b8a407.png?v=1769510761",
        'WOMEN CLOTHING': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_10_c4bfcffe-edb4-4bb5-980f-4801f7afb453.jpg?v=1768913234",
        'MEN CLOTHING': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_4_2c37e5c0-e4c8-49b0-bf4e-27b2e8c3ee3b.jpg?v=1768911116",
        'FABRICS': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_3_f1448da7-7581-41d1-9e29-3da73406525d.jpg?v=1768901286",
        'HOME & DECOR': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/Ajrakh_Bed_Covers_11.jpg?v=1768911202",
        'JEWELLERY & ACCESSORIES': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_6_b48d3e0a-5746-4106-9f55-ef9d1927603c.jpg?v=1768911475",
        'BAGS & STATIONERY': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_8_9e97ef34-f397-41ae-b2ea-2841472c61b8.jpg?v=1768911688",
        'CRAFTS OF INDIA': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_11_d4caf887-7efd-41fd-baf2-4327a0e0e507.jpg?v=1768913632",
        'HOLI \'26': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_4_1b08678d-285a-4af0-beb8-1b302b4e1ea0.jpg?v=1777968759",
        'WEDDING \'26': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_4_1b08678d-285a-4af0-beb8-1b302b4e1ea0.jpg?v=1777968759",
        'DRESS MATERIALS': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_2_071bf0e7-7cbe-412a-981c-a7b429a9010a.jpg?v=1768901045",
        'SAREES': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/Banarasi_Sarees_11_bc6c96e4-5ddc-4fcf-8940-fad010df2d6c.jpg?v=1768912525",
        'DUPATTAS & STOLES': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_4b556c4c-5329-4a72-ad88-d0010185b38e.jpg?v=1768912092",
        'Woolen \'26': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/Banner_9752fe7a-861b-42f0-b6a1-0e8f3d6cfe52.png",
        'WOOLEN \'26': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/Banner_9752fe7a-861b-42f0-b6a1-0e8f3d6cfe52.png",
        'RAKHI \'26': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/BeFunky-collage_4_f51ea3f7-18a9-48ac-ba36-51e7b22c958b.jpg?v=1778577665" ,
        'FESTIVE \'26': "https:\/\/cdn.shopify.com\/s\/files\/1\/0155\/8131\/files\/Festival_8d78a9c6-931c-4549-8391-301791d3bf56.jpg?v=1784985799"
      };

      const subtitleMap = {
        'FABRICS': '"By the Metre"',
        'DRESS MATERIALS': '"Unstitched 3-Piece Sets"'
      };

      const iconMap = {
        'WHOLESALE QUERIES': 'https://cdn.shopify.com/s/files/1/0155/8131/files/wholesaler_1.png?v=1746774587',
        'GIFTING': 'https://cdn.shopify.com/s/files/1/0155/8131/files/gift.png?v=1746774589',
        'OCCASIONS & FESTIVALS': 'https://cdn.shopify.com/s/files/1/0155/8131/files/party-ornament.png?v=1746774588',
        'BLOGS': 'https://cdn.shopify.com/s/files/1/0155/8131/files/article.png?v=1746774589',
        'FAQs': 'https://cdn.shopify.com/s/files/1/0155/8131/files/question.png?v=1746774588',
        'CONTACT US': 'https://cdn.shopify.com/s/files/1/0155/8131/files/contact-mail_1.png?v=1746774589',
        'ARTISAN REWARDS': 'https://cdn.shopify.com/s/files/1/0155/8131/files/header_gift.png?v=1754370492',
        'FABRIC CARE COMPENDIUM': 'https://cdn.shopify.com/s/files/1/0155/8131/files/fabric-care-compendium.png?v=1784207358',
      };

      const root = document.querySelector('.tws-l1-panel');
      if (!root) return console.warn('Missing .tws-l1-panel');

      const tiles = Array.from(root.querySelectorAll(':scope > .tws-l1, :scope > a.tws-l1.solo'));
      const grid = document.createElement('div');
      grid.className = 'menu-grid';

      const renderTile = (el, text) => {
        el.classList.add('menu-img-tile');
        el.style.backgroundImage = `url("${imgSrc[text]}")`;
        el.innerHTML = '';
        /*
        if (text === 'NEW!') {
          el.classList.add('full');
        } else if (text === 'CRAFTS OF INDIA') {
          el.classList.add('full');
        } else if (text === 'Woolen \'26') {
        el.classList.add('full');
        } else if (text === 'WEDDING \'26' || text === "WEDDING \u201826") {
          el.classList.add('full');
        } else if (text === 'RAKHI \'26' || text === "RAKHI '26") {
          el.classList.add('full');
        } else if (
          text === 'HOLI 26' ||
          text === "HOLI '26" ||
          text === 'HOLI ’26'
        ) {
          el.classList.add('full');
        }
        */
        if (text === 'NEW!') {
          el.classList.add('full');
        } else if (text === 'CRAFTS OF INDIA') {
          el.classList.add('full');
        } else if (text === 'Woolen \'26' || text === 'WOOLEN \'26') {
          el.classList.add('full');
        } else if (text === 'WEDDING \'26' || text === "WEDDING \u201826") {
          el.classList.add('full');
        } else if (text === 'RAKHI \'26' || text === "RAKHI '26") {
          el.classList.add('full');
        } else if (
          text === 'HOLI 26' ||
          text === "HOLI '26" ||
          text === 'HOLI ’26'
        ) {
          el.classList.add('full');
        }

        const overlay = document.createElement('div');
        overlay.className = 'tile-overlay';

        const subtitle = subtitleMap[text];
        const subtitleHTML = subtitle ? `<span class="tile-subtitle">${subtitle}</span>` : '';

        overlay.innerHTML = `<span class="tile-label">${text}${subtitleHTML}</span>`;
        el.appendChild(overlay);


        return el;
      };

      const newItem = tiles.find(el => el.textContent.trim() === 'NEW!');
      if (newItem) grid.appendChild(renderTile(newItem, 'NEW!'));

      tiles.forEach(el => {
        const text = el.textContent.trim();
        if (text !== 'NEW!' && text !== 'CRAFTS OF INDIA' && text !== "WEDDING '26" && text !== "RAKHI '26" && imgSrc[text]) {
          grid.appendChild(renderTile(el, text));
        }
      });

      const lastItem = tiles.find(el => el.textContent.trim() === 'CRAFTS OF INDIA');
      if (lastItem) grid.appendChild(renderTile(lastItem, 'CRAFTS OF INDIA'));

      const weddingItem = tiles.find(el => el.textContent.trim() === "WEDDING '26");
      if (weddingItem && imgSrc["WEDDING '26"]) {
        const tile = renderTile(weddingItem, "WEDDING '26");
        const link = weddingItem.dataset.link;
        if (link && weddingItem.tagName !== 'A') {
          tile.style.cursor = 'pointer';
          tile.addEventListener('click', () => { window.location.href = link; });
        }
        grid.appendChild(tile);
      }

      const rakhiItem = tiles.find(el => el.textContent.trim() === "RAKHI '26");
      if (rakhiItem && imgSrc["RAKHI '26"]) {
        const tile = renderTile(rakhiItem, "RAKHI '26");
        const link = rakhiItem.dataset.link;
        if (link && rakhiItem.tagName !== 'A') {
          tile.style.cursor = 'pointer';
          // tile.addEventListener('click', () => { window.location.href = link; });
        }
        grid.appendChild(tile);
      }

      root.insertBefore(grid, root.firstChild);

      const smallMenu = root.querySelector('.small-menu');
      if (smallMenu) {
        const links = smallMenu.querySelectorAll('a.tws-l1.solo');
        links.forEach(link => {
          const label = link.textContent.trim();
          const icon = iconMap[label];
          if (icon) {
            const img = document.createElement('img');
            img.src = icon;
            img.alt = label;
            link.prepend(img);
          }
        });
      }
    }) ();

// review code
(() => {
  const reviews = [
    {
      initials: "DR",
      name: "DEEPTEE RELE",
      date: "Sep 06, 2026",
      rating: 5,
      text: "Bandhaani shawl excellent. \nEverybody like it.\nIt was appreciated a lot by a lady to whom I gifted  to honour her."
    },
    {
      initials: "SS",
      name: "SUE S E SHANNON",
      date: "Sep 06, 2026",
      rating: 5,
      text: "My cotton fabrics and bed sheet arrived fast. Opening the box was exciting, such lovely colours. Customer service was helpful, the note was a lovely touch."
    },
    {
      initials: "SM",
      name: "SUSMITA MOHAPATRA",
      date: "Sep 05, 2026",
      rating: 5,
      text: "My first iTokri order and I am impressed. Quality is exactly as expected, delivery was fast, everything smooth. Very happy, will surely order again. ❤️"
    },
    {
      initials: "RS",
      name: "DR RUBBINA SHAIKH",
      date: "Sep 04, 2026",
      rating: 5,
      text: "As a first time buyer I was sceptical, but the Hakoba and printed cotton went far beyond expectations. Pure cotton, a handwritten note, and surprise earrings won my heart."
    }
  ];

      const root = document.querySelector(".tws-l1-panel");
      const smallMenu = root?.querySelector(".small-menu");
      if (!root || !smallMenu) return;

      const section = document.createElement("div");
      section.className = "reviews-section";

      const cardsHTML = reviews.map(r => `
            <div class="reviews-card">
              <div class="reviews-header">
                <div class="reviews-left">
                  <div class="reviews-initials">${r.initials}</div>
                  <div class="reviews-meta">
                    <div class="reviews-name">${r.name}</div>
                    <div class="reviews-date">${r.date}</div>
                  </div>
                </div>
                <div class="reviews-stars-wrapper">
                <div class="reviews-stars">★★★★★</div>
                </div>
              </div>
              <div class="reviews-text">${r.text}</div>
            </div>
          `).join("");

        section.innerHTML = `
              <div class="reviews-wrapper">
                <div class="reviews-container">${cardsHTML}</div>
              </div>
            <div class="pagination-dots">
          ${reviews.map((_, i) => `<div class="reviews-dot${i === 0 ? ' active' : ''}"></div>`).join("")}
        </div>`;

      root.insertBefore(section, smallMenu);

      let current = 0;
      const container = section.querySelector(".reviews-container");
      const dots = section.querySelectorAll(".reviews-dot");

      const slide = index => {
        container.style.transform = `translateX(-${index * 100}%)`;
        dots.forEach((dot, i) => dot.classList.toggle("active", i === index));
        current = index;
      };

      dots.forEach((dot, i) => {
        dot.addEventListener("click", () => slide(i));
      });

      setInterval(() => {
        const next = (current + 1) % reviews.length;
        slide(next);
      }, 3000);
    }) ();



    //   Header 
    const details = document.getElementById('Details-menu-drawer-container');
    const summary = details?.querySelector('summary.header__icon--menu');
    const drawer = document.getElementById('menu-drawer');

    const oldHeader = drawer.querySelector('.drawer-header-wrapper');
    if (oldHeader) oldHeader.remove();

    const headerHTML = `
      <div class="drawer-header-wrapper" style="display: flex; align-items: center; justify-content: space-between; padding: 10px 20px;">
        <img src="https://itokri.com/cdn/shop/files/Group_1458_2x_95f81960-e86c-4e73-a9e2-9b93370be915.png?v=1660109560&width=160" class="logonew" style="height: 30px;">
        <button class="drawer-close-btn" style="background: none; border: none; cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-close" fill="none" viewBox="0 0 18 17" width="24" height="24">
            <path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></path>
          </svg>
        </button>
      </div>
    `;
    drawer.insertAdjacentHTML('afterbegin', headerHTML);

    function unlockScroll() {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
    }

    drawer.querySelector('.drawer-close-btn').addEventListener('click', () => {
      details.removeAttribute('open');
      details.classList.remove('mobile-menu-drawer-open');
      const overlay = document.querySelector('.menu-drawer__overlay, .overlay, .drawer__overlay');
      if (overlay) overlay.style.display = 'none';
      if (summary) summary.setAttribute('aria-expanded', 'false');

      unlockScroll();
    });

    const overlay = document.querySelector('.menu-drawer__overlay, .overlay, .drawer__overlay');
    if (overlay) {
      overlay.style.display = 'block';
      overlay.onclick = () => {
        details.removeAttribute('open');
        overlay.style.display = 'none';
        if (summary) summary.setAttribute('aria-expanded', 'false');

        unlockScroll();
      };
    }

    // Make FESTIVE 2025 full-width like CRAFTS OF INDIA // AND DO SAME FOR OTHERS IN FUTURE
    function forceRakhiFullTile() {
      const grid = document.querySelector('.menu-grid');
      if (!grid) return setTimeout(forceRakhiFullTile, 300);

      const rakhiTile = Array.from(grid.children).find(el => el.textContent.trim().includes('WEDDING \'26'));

      if (rakhiTile && !rakhiTile.classList.contains('full')) {
        rakhiTile.classList.add('full');

        // NEW! has 'tile-no-overlay', apply it here too so it will not show text over it if image has text already
        // rakhiTile.classList.add('tile-no-overlay'); // uncomment if needed
      } else if (!rakhiTile) {
        // Retry if not found yet
        setTimeout(forceRakhiFullTile, 300);
      }
    }

    forceRakhiFullTile();
    // Make RAKHI 2025 full-width like CRAFTS OF INDIA END
        
      } else if (!document.querySelector('.CP_IT_Sitewide_03_shopify')) {
      window.requestAnimationFrame(window.CP_IT_Sitewide_03_shopify);
    }
  };

window.CP_IT_Sitewide_03_shopify();
